/** Run one reporting dependency without coupling its result to sibling requests. */
export function loadReportingResource({request, isActive, onSuccess, onError, onFinally}) {
    return Promise.resolve()
        .then(request)
        .then((value) => {
            if (isActive()) onSuccess(value);
        })
        .catch((error) => {
            if (isActive()) onError(error);
        })
        .finally(() => {
            if (isActive()) onFinally();
        });
}

/** Join late-arriving project metadata onto report rows without reloading the report. */
export function mergeReportingRowMetadata(rows, metadata, {getRowId, getMetadataId, property}) {
    const metadataById = new Map((metadata ?? [])
        .map((item) => [getMetadataId(item), item])
        .filter(([id]) => id !== null && id !== undefined));

    return (rows ?? []).map((row) => ({
        ...row,
        [property]: metadataById.get(getRowId(row)) ?? row[property],
    }));
}
